import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreApisService } from '../core-apis.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-banking-operations',
  templateUrl: './banking-operations.component.html',
  imports: [CommonModule, ToHtmlPipe],
})
export class BankingOperationsComponent implements OnInit, OnDestroy {
  isPlaying = false;

  constructor(private coreApiPageService: CoreApisService) {
    this.subscriptions = [];
  }
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  bankingData: any;
  subscriptions: Subscription[];

  videoUrl: string = '';
  videoThumbnail: string = '';

  ngOnInit(): void {
    this.coreApiPageService.banking$.subscribe(data => {
      if (data !== null) {
        this.bankingData = {
          header: data?.title,
          cards: data?.component1.slice(0, 3),
          videoCard: data?.component1[3].fields,
          description: data?.content?.content[0]?.content[0]?.value,
          tagName: data?.tags[0]?.fields?.tagName.toUpperCase(),
        };
        this.videoUrl = `https:${this.bankingData?.videoCard?.imageicon?.fields?.file?.url}`;
        this.videoThumbnail = `https:${this.bankingData?.videoCard?.linkedElements?.[0]?.fields?.iconImage?.fields?.file?.url}`;
      }
    });
  }

  navigateToVertoFX(link:any) {
    location.pathname = link;
  }

  playVideo(videoPlayer: HTMLVideoElement) {
    videoPlayer.play();
    this.isPlaying = true;
  }

  onPlay() {
    this.isPlaying = true;
  }

  onPause() {
    this.isPlaying = false;
  }
}
